import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { updateProfleAction } from "../../../redux/actions/user/userAction";
import { competenceScore } from "../helper/index";
import { connect } from "react-redux";
import { DialogLeavingPage } from "../../utils/core/blocknavigation/DialogLeavingPage";
import { useNavigatingAway } from "../../utils/core/blocknavigation/useNavigatingAway";

export const CompetenciesScore = (props) => {
  const customStyles = {
    control: (base, state) => ({
      ...base,
      top: "5px",
      // Overwrittes the different states of border
      borderColor: state.isFocused ? "#309CCA" : "#309CCA",
    }),
  };

  const dispatch = useDispatch();

  const [inputData, setInputData] = useState([]);

  const [isEnable, setIsEnable] = useState({
    save: false,
  });
  const [canShowDialogLeavingPage, setCanShowDialogLeavingPage] =
    useState(false);
  const [showDialogLeavingPage, confirmNavigation, cancelNavigation] =
    useNavigatingAway(canShowDialogLeavingPage);

  const handleChange = (event, eventName) => {
    setIsEnable((prevState) => ({ ...prevState, save: true }));
    setCanShowDialogLeavingPage(true);

    if (event != null) {
      setInputData((prevState) => ({
        ...prevState,
        [eventName]: event["id"],
      }));
    } else {
      setInputData((prevState) => ({ ...prevState, [eventName]: null }));
    }
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const updateSector = {
      id: inputData.id,
      profile: inputData.profile,
      businessAwarenessObjectives: inputData.businessAwarenessObjectives,
      safetyWelfareCommitments: inputData.safetyWelfareCommitments,
      performanceObjectiveSettingMeasurement:
        inputData.performanceObjectiveSettingMeasurement,
      statutoryRegulatoryComplianceAwareness:
        inputData.statutoryRegulatoryComplianceAwareness,
      hSECompliance: inputData.hSECompliance,
      riskAssessment: inputData.riskAssessment,
      coachingMonitoring: inputData.coachingMonitoring,
      functionalCategoryInterfaceAwareness:
        inputData.functionalCategoryInterfaceAwareness,
      planningReportingSystems: inputData.planningReportingSystems,
      commercialBudgetAwareness: inputData.commercialBudgetAwareness,
      jobSpecificProcessesSystems: inputData.jobSpecificProcessesSystems,
      performingWorkSystems: inputData.performingWorkSystems,
    };
    const data = {
      userId: props.profile.userId,
      competenceScore: [updateSector],
      performance_score: competenceScore(updateSector, props.competenciesScore),
    };
    dispatch(updateProfleAction(props.profile.userId, data));
    setIsEnable((prevState) => ({ ...prevState, save: false }));
    setCanShowDialogLeavingPage(false);
  };

  useEffect(() => {
    if (Object.keys(props.profile).length > 0) {
      const userData = {
        id: props.profile.competenceScore[0].id,
        profile: props.profile.competenceScore[0].profile,
        businessAwarenessObjectives:
          props.profile.competenceScore[0].businessAwarenessObjectives,
        safetyWelfareCommitments:
          props.profile.competenceScore[0].safetyWelfareCommitments,
        performanceObjectiveSettingMeasurement:
          props.profile.competenceScore[0]
            .performanceObjectiveSettingMeasurement,
        statutoryRegulatoryComplianceAwareness:
          props.profile.competenceScore[0]
            .statutoryRegulatoryComplianceAwareness,
        hSECompliance: props.profile.competenceScore[0].hSECompliance,
        riskAssessment: props.profile.competenceScore[0].riskAssessment,
        coachingMonitoring: props.profile.competenceScore[0].coachingMonitoring,
        functionalCategoryInterfaceAwareness:
          props.profile.competenceScore[0].functionalCategoryInterfaceAwareness,
        planningReportingSystems:
          props.profile.competenceScore[0].planningReportingSystems,
        commercialBudgetAwareness:
          props.profile.competenceScore[0].commercialBudgetAwareness,
        jobSpecificProcessesSystems:
          props.profile.competenceScore[0].jobSpecificProcessesSystems,
        performingWorkSystems:
          props.profile.competenceScore[0].performingWorkSystems,
      };
      setInputData(userData);
    }
  }, [props]);

  return (
    <div className="row margin-row">
      <div className="col-12  ">
        <div className="timeline-border-box">
          <h5>Competencies Appraisal</h5>
          <div className="row">
            <DialogLeavingPage
              showDialog={showDialogLeavingPage}
              setShowDialog={setCanShowDialogLeavingPage}
              confirmNavigation={confirmNavigation}
              cancelNavigation={cancelNavigation}
              title={"Competencies Appraisal"}
            />
            <div className="col-md-6 col-12" style={{ paddingTop: "1.5%" }}>
              <label className="field-label">
                Business Awareness Objectives
              </label>
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <Select
                id="businessAwarenessObjectives"
                name="businessAwarenessObjectives"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.businessAwarenessObjectives
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "businessAwarenessObjectives")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Safety & Welfare Commitments
              </label>
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <Select
                id="safetyWelfareCommitments"
                name="safetyWelfareCommitments"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.safetyWelfareCommitments
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "safetyWelfareCommitments")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Performance Objective Setting & Measurement
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="performanceObjectiveSettingMeasurement"
                name="performanceObjectiveSettingMeasurement"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.performanceObjectiveSettingMeasurement
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "performanceObjectiveSettingMeasurement")
                }
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Statutory & Regulatory Compliance Awareness
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="statutoryRegulatoryComplianceAwareness"
                name="statutoryRegulatoryComplianceAwareness"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.statutoryRegulatoryComplianceAwareness
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "statutoryRegulatoryComplianceAwareness")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">HSE Compliance</label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="hSECompliance"
                name="hSECompliance"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id === inputData.hSECompliance
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "hSECompliance")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Risk Assessment & Mitigation Techniques
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="riskAssessment"
                name="riskAssessment"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id === inputData.riskAssessment
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "riskAssessment")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">Coaching & Monitoring</label>
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <Select
                id="coachingMonitoring"
                name="coachingMonitoring"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id === inputData.coachingMonitoring
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) => handleChange(event, "coachingMonitoring")}
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Functional & Category Interface Awareness
              </label>
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <Select
                id="functionalCategoryInterfaceAwareness"
                name="functionalCategoryInterfaceAwareness"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.functionalCategoryInterfaceAwareness
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "functionalCategoryInterfaceAwareness")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Planning & Reporting Systems
              </label>
            </div>
            <div className="col-md-6 col-12 " style={{ paddingTop: "1%" }}>
              <Select
                id="planningReportingSystems"
                name="planningReportingSystems"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.planningReportingSystems
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "planningReportingSystems")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Commercial & Budget Awareness
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="commercialBudgetAwareness"
                name="commercialBudgetAwareness"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.commercialBudgetAwareness
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "commercialBudgetAwareness")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Category / Job Specific Processes & Systems
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="jobSpecificProcessesSystems"
                name="jobSpecificProcessesSystems"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id ===
                      inputData.jobSpecificProcessesSystems
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "jobSpecificProcessesSystems")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <label className="field-label">
                Control & Performing of Work Systems
              </label>
            </div>
            <div className="col-md-6 col-12" style={{ paddingTop: "1%" }}>
              <Select
                id="performingWorkSystems"
                name="performingWorkSystems"
                value={
                  props.competenciesScore &&
                  props.competenciesScore.find(
                    (competenciesScore) =>
                      competenciesScore.id === inputData.performingWorkSystems
                  )
                }
                options={props.competenciesScore}
                getOptionLabel={(option) => option.competencies_score}
                getOptionValue={(option) => option.id}
                onChange={(event) =>
                  handleChange(event, "performingWorkSystems")
                }
                placeholder="Choose.."
                isClearable={true}
                styles={customStyles}
              />
            </div>
          </div>{" "}
          <br />
          <div className="col text-right ">
            {isEnable.save ? (
              <Link className="edit-btn" to="" onClick={handleFormSubmit}>
                
                <span>
                  <img src="/assets/images/icons/save.png" alt="" />Save
                </span>
              </Link>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const user = state.user.user;
  const profile = state.user.profile;
  const competenciesScore = state.admin.competenciesScore;

  return {
    user: user,
    profile: profile,
    competenciesScore: competenciesScore,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(CompetenciesScore);
